<template>  
  <v-dialog    
    v-model="value"    
    persistent
    scrollable
    width="700">
    <v-card  >          
      <v-toolbar card>
        <v-toolbar-title>{{$t('Admin.MissionPlanTemplate.Form.AddWaypoint')}}</v-toolbar-title>   
          <v-spacer />
        <v-toolbar-items>              
          <v-btn icon small @click="show(false)"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar-items>         
    </v-toolbar>              
      <v-card-text>     
        <v-layout column wrap>    
          <div class="liste wpts" >
            <div class="line-item" >
                  <div class="heading ml-2" style="display:flex;">                                              
                      {{$t('Admin.MissionPlanTemplate.Form.AddWaypoint')}}
                      <v-spacer/>
                      <v-btn icon small @click="addWaypoint({},true)" :title="$t('Admin.MissionPlanTemplate.Form.SelectTooltip')"><v-icon>mdi-plus</v-icon></v-btn>
                  </div>
              </div>
          </div>                    
          <h2 class="mt-4">{{$t('Admin.MissionPlanTemplate.Form.GlobalWaypoints')}}</h2>
          <div ref="liste" class="liste wpts" >
            <div class="line-item" v-for="wpt in globalWpts" :key="wpt.id">
                  <div class="heading ml-2" style="display:flex;">                                              
                      {{formatWaypoint(wpt)}}
                      <v-spacer/>
                      <v-btn icon small @click="addWaypoint(wpt)" :title="$t('Admin.MissionPlanTemplate.Form.SelectTooltip')"><v-icon>mdi-plus</v-icon></v-btn>
                  </div>
              </div>
          </div>                      
        </v-layout>  
      </v-card-text>        
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import Component from 'vue-class-component'
import { MissionPlanUiState } from '../../../models/ui/MissionPlanUiState'
import { IMissionPlanWaypoint } from '../../../models/iris/missionPlan/IMissionPlanWaypoint'

@Component({
  name: 'AdminMissionPlanGlobalWptDialog',
  props:{             
    value:{
        type:Boolean,
        required:true,
    }
  }
})
export default class AdminMissionPlanGlobalWptDialog extends Vue {  
  
  //control select popup of global waypoint visibility  
  value!:boolean  
  uiid!:string


  show(show:boolean) {        
    this.$emit('input',show);
  }
    
  //Global waypoints array  
  get globalWpts(){
    return this.$store.myGetters.positionRemarquables.map(p => {return {id:p.id,wpt_label:p.prmLibelle,wpt_lat:p.gpsLat,wpt_lon:p.gpsLon}})
  }

  formatWaypoint(wpt:IMissionPlanWaypoint) {    
    return wpt.wpt_label&&wpt.wpt_label.length>0?wpt.wpt_label:this.toCoordString(wpt)
  }

  toCoordString(wpt:IMissionPlanWaypoint){
    //@ts-ignore    
    return this.$options.filters[this.$store.myGetters.coordFormatFilter]([wpt.wpt_lon,wpt.wpt_lat])
  }
  
  addWaypoint(wpt:IMissionPlanWaypoint,edit = false) {  
    this.$emit('addWaypoint',{wpt,edit});    
    this.show(false)
  }
  
  /*Cycle de vie*/
  created() {      
    this.$store.myActions.POSITIONREMARQUABLE_ENSURE_LIST()
  }
  
}
</script>
<style>

</style>